import { AlertIcon, CheckIcon, RefreshIcon } from './icons';
import { Button } from './Button';
import { OFFLINE_TEXT, RECONNECTED_TEXT, RESUME_LABEL, RESUME_TEXT } from '../utils/connectivity.js';
import './ConnectivityBanner.css';

/**
 * Bandeau de connexion (UI-11), au-dessus du champ de saisie. `state` (connectivityBanner) :
 * « offline » (envoi bloqué), « resume » (réseau revenu, dernière réponse interrompue :
 * bouton « Relancer », onResume), « reconnected » (réseau revenu, rien à relancer), null.
 * La région d'annonce reste dans la page, même vide : chaque changement est lu par les
 * lecteurs d'écran (role="status", annonce polie).
 */
export function ConnectivityBanner({ state = null, onResume = null }) {
  return (
    <div className="connectivity" role="status" aria-live="polite">
      {state === 'offline' && (
        <p className="connectivity__banner connectivity__banner--offline">
          <AlertIcon size={16} />
          <span className="connectivity__text">{OFFLINE_TEXT}</span>
        </p>
      )}
      {state === 'resume' && (
        <div className="connectivity__banner connectivity__banner--resume">
          <RefreshIcon size={16} />
          <span className="connectivity__text">{RESUME_TEXT}</span>
          {onResume && (
            <Button size="sm" className="connectivity__action" onClick={onResume}>
              {RESUME_LABEL}
            </Button>
          )}
        </div>
      )}
      {state === 'reconnected' && (
        <p className="connectivity__banner connectivity__banner--online">
          <CheckIcon size={16} />
          <span className="connectivity__text">{RECONNECTED_TEXT}</span>
        </p>
      )}
    </div>
  );
}
